import { render, staticRenderFns } from "./install-old.vue?vue&type=template&id=550c5757"
import script from "./install-old.vue?vue&type=script&lang=js"
export * from "./install-old.vue?vue&type=script&lang=js"
import style0 from "./install-old.vue?vue&type=style&index=0&id=550c5757&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports